import api from "@/services/api";

class GetAllCategories  {
    execute = async ()=>{
        const categories = await api().get('/partners/categories')

        return categories
    }
}

export {GetAllCategories}